export default "__VITE_ASSET__CYvJHTGl__"